export const INDEX_NAME = 'prod_Content';
export const ALL_CATEGORIES = ['knowledgebase', 'documentation', 'templates'];
export const HELPDESK_CATEGORY_ALL = 'article';
